module.exports = __webpack_public_path__ + "static/media/signal-2.e84fdcb3.svg";